import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
if (!BASE_URL) {
    // Fail loudly at boot rather than producing confusing 404s
    // eslint-disable-next-line no-console
    console.error("REACT_APP_BACKEND_URL is not set. The frontend cannot reach the API.");
}

const api = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: { "Content-Type": "application/json" },
    timeout: 20000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("kl_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Map server error shape to a consistent client error
        const status = error?.response?.status;
        const data = error?.response?.data;
        const message =
            (data && (data.message || data.error || data.detail)) ||
            error.message ||
            "Network error";

        if (status === 401) {
            // Don't trigger redirect on auth endpoints themselves
            const url = error?.config?.url || "";
            if (!url.includes("/auth/login") && !url.includes("/auth/register")) {
                localStorage.removeItem("kl_token");
            }
        }

        return Promise.reject({ status, message, data });
    },
);

export default api;
